import { useMemo } from "react";
import { useLocation } from "react-router";
import { EventTypeOptionResource } from "../types/eventType";
import { isEventAddressStepValid } from "./save/EventAddressStep";
import { isEventBaseDataStepValid } from "./save/EventBaseDataStep";
import { isEventDetailsStepValid } from "./save/EventDetailsStep";
import { isEventParticipationStepValid } from "./save/EventParticipationStep";
import { isEventPlannedCostStepValid } from "./save/EventPlannedCostStep";
import { EventStep } from "./save/EventStepper";
import {
	shouldSkipAddressStep,
	shouldSkipDetailsStep,
	shouldSkipParticipationStep,
	shouldSkipPlannedCostStep,
	shouldSkipUsersStep,
} from "./save/eventStepperUtils";
import { isEventUsersStepValid } from "./save/EventUsersStep";

export const eventSteps: EventStep[] = [
	{ label: "Base data", isValid: isEventBaseDataStepValid, key: "base-data" },
	{ label: "Address", isValid: isEventAddressStepValid, key: "address" },
	{ label: "Users", isValid: isEventUsersStepValid, key: "users" },
	{ label: "Participation", isValid: isEventParticipationStepValid, key: "participation" },
	{ label: "Cost categories", isValid: isEventPlannedCostStepValid, key: "planned-cost" },
	{ label: "Details", isValid: isEventDetailsStepValid, key: "details" },
];

export function useFilteredEventSteps(eventType: EventTypeOptionResource | null) {
	const { pathname } = useLocation();

	const { filteredSteps, currentStep } = useMemo(() => {
		let filteredSteps = eventSteps;
		if (shouldSkipAddressStep(eventType)) {
			filteredSteps = filteredSteps.filter((step) => step.key !== "address");
		}
		if (shouldSkipUsersStep(eventType)) {
			filteredSteps = filteredSteps.filter((step) => step.key !== "users");
		}
		if (shouldSkipParticipationStep(eventType)) {
			filteredSteps = filteredSteps.filter((step) => step.key !== "participation");
		}
		if (shouldSkipPlannedCostStep(eventType)) {
			filteredSteps = filteredSteps.filter((step) => step.key !== "planned-cost");
		}
		if (shouldSkipDetailsStep(eventType)) {
			filteredSteps = filteredSteps.filter((step) => step.key !== "details");
		}
		const splitPath: string[] = pathname.split("/");
		const currentStep = filteredSteps.find((step) => step.key === splitPath[splitPath.length - 1]);
		if (!currentStep) {
			throw new Error("Current step not found");
		}
		return { filteredSteps, currentStep };
	}, [eventType, pathname]);

	return { filteredSteps, currentStep };
}
